import * as THREE from 'three';
import { WindowService } from './WindowService';
import { DebugService } from './DebugService';
import { TickService } from './TickService';
import { SizesInterface } from './WindowService';
import { LoaderController } from './LoaderService';
import { LightingService } from './LightingService';
import { CameraService } from '../core/CameraService';
import { Scene } from '../Scene';
import { TweenService } from './TweenService';

export class Core {
	/**
	 * Core Properties
	 * */
	sizes: SizesInterface;
	windowSizer: WindowService;
	canvas: HTMLCanvasElement;
	threeScene: THREE.Scene;
	scene: Scene;
	renderer: THREE.WebGLRenderer;

	/**
	 * Services
	 * */
	services: any[] = [];

	/**
	 * Debug mode
	 * */
	debugMode: boolean;

	/**
	 * Constructor
	 * */
	constructor(canvas: HTMLCanvasElement, sizes: SizesInterface, debugMode: boolean = false) {
		this.debugMode = debugMode;
		this.canvas = canvas;
		this.sizes = sizes;
		this.threeScene = new THREE.Scene();
		this.threeScene.background = new THREE.Color('#19524B');
		this.renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true });
		this.renderer.outputColorSpace = THREE.SRGBColorSpace; // || LinearSRGBColorSpace

		// Add debug services if required
		this.registerService('Debug', new DebugService(this, debugMode));

		// Register core services
		this.registerService('Loader', new LoaderController());
		this.registerService('Lighting', new LightingService(this));
		this.registerService('Camera', new CameraService(this));
		this.registerService('Tick', new TickService(this));
		this.registerService('Tween', new TweenService(this));

		// Watch the screen
		this.windowSizer = new WindowService(this);
		this.windowSizer.resize();
		this.windowSizer.watchResize();

		// Load the scene
		this.scene = new Scene(this);

		return this;
	}

	/**
	 * Returns a Service
	 * @param {string} serviceName The name of a service
	 * */
	s(serviceName: string) {
		try {
			return this.services.find((s) => s.name == serviceName).instance;
		} catch(e) {
			console.log(`Cannot load service: ${serviceName}`);
		}
	}

	/**
	 * Registers a manager that will be accessible to the main scope
	 * */
	registerService(serviceName: string, instance: any) {
		this.services.push({ name: serviceName, instance: instance });
	}
}
